import*as t from"react";const r="https://cloud.wordlift.io/app/bootstrap.js";function e({ScriptComponent:e,isWordLiftScriptEnabled:o}){return o?t.createElement(e,{async:!0,type:"text/javascript",strategy:"afterInteractive",src:r}):null}export{r as SCRIPT_URL,e as WordLift};
//# sourceMappingURL=wordlift.js.map
